import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  label: {
    marginBottom: 6,
    color: '#071B27',
    textTransform: 'uppercase',
    fontSize: 10,
    lineHeight: '12px',
    letterSpacing: '0.035em'
  },
  customTimePicker: {
    zIndex: '0',
    position: 'relative',
    borderRadius: 3,
    border: '1px solid #BECEDA',
    '&:hover': {
      border: '1px solid #41B7D7'
    }
  },
  scheduleIcon: {
    position: 'absolute',
    fontSize: '21px',
    left: '10px',
    top: '7px'
  },
  error: {
    border: '1px solid #EB5757',
    '&:hover': {
      border: '1px solid #EB5757'
    }
  }
});
